module.exports = __webpack_public_path__ + "static/media/SkyDrone.71d790b4.png";